export default __webpack_public_path__ + "static/media/Champagne-HD-Wallpaper.590e8172.jpg";